export const APP_NAME = 'perso-v3';
export const APP_ENV = import.meta.env.VITE_ENV;
export const PASS_URL = import.meta.env.VITE_URL;
export const API_END_POINT = import.meta.env.VITE_API_END_POINT;
export const HOST_MB: number =
    (JSON.parse(import.meta.env.VITE_HOST_MB ?? '{}') as Record<string, number>)[window.location.host] || 43397;
export const BRAND_NAME = HOST_MB === 43397 ? 'APRIL Moto' : 'AM Gestion';
export const APP_CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const APP_GRANT_TYPE = import.meta.env.VITE_GRANT_TYPE;
export const APP_PROVIDER = import.meta.env.VITE_PROVIDER;
export const GRAVITEE_API_KEY = import.meta.env.VITE_GRAVITEE_API_KEY_IBAN;
export const GRAVITEE_URL = import.meta.env.VITE_GRAVITEE_URL;
export const SERVICES_URL = import.meta.env.VITE_SERVICES_URL;
export const WHEELS_URL = import.meta.env.VITE_WHEELS_URL;

// MFA (Gravitee AM) — mettre à false pour revenir au login classique en cas d'urgence
export const AUTH_GRAVITEE_ENABLED = import.meta.env.VITE_AUTH_GRAVITEE_ENABLED !== 'false';

// Maintenance planifiée — mettre à true pour afficher la page de maintenance à la place de l'app
export const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === 'true';

// Gravitee AM — sélection par marque selon le hostname
const isAmgestion = window.location.host.includes('amgestionassurance.com');

export const GRAVITEE_AM_BASE_URL = isAmgestion
    ? import.meta.env.VITE_GRAVITEE_AM_BASE_URL_AMGESTION
    : import.meta.env.VITE_GRAVITEE_AM_BASE_URL_MOTO;
export const GRAVITEE_AM_REDIRECT_URI = `${window.location.origin}/login/callback`;
export const GRAVITEE_AM_CLIENT_ID = isAmgestion
    ? import.meta.env.VITE_GRAVITEE_AM_CLIENT_ID_AMGESTION
    : import.meta.env.VITE_GRAVITEE_AM_CLIENT_ID_MOTO;

export const FAQ_TYPE_CLIENT_DIRECT = 1;
export const FAQ_TYPE_CLIENT_COURTIER = 2;
